import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=28cda328&scoped=true"
import script from "./patient.vue?vue&type=script&lang=js"
export * from "./patient.vue?vue&type=script&lang=js"
import style0 from "./patient.vue?vue&type=style&index=0&id=28cda328&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cda328",
  null
  
)

export default component.exports